// src/components/AppComponents/Sidebar/CustomerMenu/CustomerMenuItemButton.tsx

import { cx } from '@UI/lib/utils';

interface CustomerMenuItemButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}
const CustomerMenuItemButton: React.FC<CustomerMenuItemButtonProps> = ({
  children,
  className,
  ...other
}) => {
  return (
    <button
      className={cx(
        'shrink-0 flex justify-start items-center group outline-none',
        'rounded-revving-default',
        'pl-4 py-2',
        'text-sm',
        'bg-transparent dark:bg-transparent',
        'hover:bg-revving-brand-faint dark:hover:bg-darkRevving-brand-faint',
        'lg:border border-revving-border dark:border-darkRevving-border',
        'hover:border-revving-border-subtle dark:hover:border-darkRevving-border-subtle',
        'w-full justify-start max-lg:pr-2.5',
        className,
      )}
      {...other}
    >
      {children}
    </button>
  );
};

export default CustomerMenuItemButton;
